/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CostPartFromJSON(json) {
    return CostPartFromJSONTyped(json, false);
}
export function CostPartFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'costId': !exists(json, 'costId') ? undefined : json['costId'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'partCodeInput': !exists(json, 'partCodeInput') ? undefined : json['partCodeInput'],
        'partCode': !exists(json, 'partCode') ? undefined : json['partCode'],
        'partIDx': !exists(json, 'partIDx') ? undefined : json['partIDx'],
        'partName': !exists(json, 'partName') ? undefined : json['partName'],
        'partWarehouse': !exists(json, 'partWarehouse') ? undefined : json['partWarehouse'],
        'partTransactionDate': !exists(json, 'partTransactionDate') ? undefined : (new Date(json['partTransactionDate'])),
        'partQuantity': !exists(json, 'partQuantity') ? undefined : json['partQuantity'],
        'partQuantityWanted': !exists(json, 'partQuantityWanted') ? undefined : json['partQuantityWanted'],
        'partQuantitySupplied': !exists(json, 'partQuantitySupplied') ? undefined : json['partQuantitySupplied'],
        'partUnits': !exists(json, 'partUnits') ? undefined : json['partUnits'],
        'partUnitCost': !exists(json, 'partUnitCost') ? undefined : json['partUnitCost'],
        'partCostInput': !exists(json, 'partCostInput') ? undefined : json['partCostInput'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'partCostType': !exists(json, 'partCostType') ? undefined : json['partCostType'],
        'partAssetId': !exists(json, 'partAssetId') ? undefined : json['partAssetId'],
    };
}
export function CostPartToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'costId': value.costId,
        'workorderId': value.workorderId,
        'propertyId': value.propertyId,
        'partCodeInput': value.partCodeInput,
        'partCode': value.partCode,
        'partIDx': value.partIDx,
        'partName': value.partName,
        'partWarehouse': value.partWarehouse,
        'partTransactionDate': value.partTransactionDate === undefined ? undefined : (value.partTransactionDate.toISOString()),
        'partQuantity': value.partQuantity,
        'partQuantityWanted': value.partQuantityWanted,
        'partQuantitySupplied': value.partQuantitySupplied,
        'partUnits': value.partUnits,
        'partUnitCost': value.partUnitCost,
        'partCostInput': value.partCostInput,
        'notes': value.notes,
        'partCostType': value.partCostType,
        'partAssetId': value.partAssetId,
    };
}
